import type {
  CancelableStatus,
  ClonableStatus,
  DownloadableStatus,
  EditableStatus,
  PreviewableStatus,
  PrintableStatus,
  QuoteRequestableStatus,
  ReadonlyStatus,
  ResendableStatus,
  SendableStatus,
} from "../types/purchaseOrderActions"
import {
  CANCELABLE_STATUSES,
  CLONABLE_STATUSES,
  DOWNLOADABLE_STATUSES,
  EDITABLE_STATUSES,
  PREVIEWABLE_STATUSES,
  PRINTABLE_STATUSES,
  QUOTE_REQUESTABLE_STATUSES,
  READONLY_STATUSES,
  RESENDABLE_STATUSES,
  SENDABLE_STATUSES,
} from "../types/purchaseOrderActions"

import type { OrderStatus } from "@/graphql/codegen/graphql"

export const isPrintableStatus = (status: OrderStatus | null | undefined): status is PrintableStatus => {
  return !!status && PRINTABLE_STATUSES.includes(status as PrintableStatus)
}

export const isDownloadableStatus = (status: OrderStatus | null | undefined): status is DownloadableStatus => {
  return !!status && DOWNLOADABLE_STATUSES.includes(status as DownloadableStatus)
}

export const isClonableStatus = (status: OrderStatus | null | undefined): status is ClonableStatus => {
  return !!status && CLONABLE_STATUSES.includes(status as ClonableStatus)
}

export const isCancelableStatus = (status: OrderStatus | null | undefined): status is CancelableStatus => {
  return !!status && CANCELABLE_STATUSES.includes(status as CancelableStatus)
}

export const isEditableStatus = (status: OrderStatus | null | undefined): status is EditableStatus => {
  return !!status && EDITABLE_STATUSES.includes(status as EditableStatus)
}

export const isSendableStatus = (status: OrderStatus | null | undefined): status is SendableStatus => {
  return !!status && SENDABLE_STATUSES.includes(status as SendableStatus)
}

export const isResendableStatus = (status: OrderStatus | null | undefined): status is SendableStatus => {
  return !!status && RESENDABLE_STATUSES.includes(status as ResendableStatus)
}

export const isReadonlyStatus = (status: OrderStatus | null | undefined): status is ReadonlyStatus => {
  return !!status && READONLY_STATUSES.includes(status as ReadonlyStatus)
}

export const isQuoteRequestableStatus = (status: OrderStatus | null | undefined): status is QuoteRequestableStatus => {
  return !!status && QUOTE_REQUESTABLE_STATUSES.includes(status as QuoteRequestableStatus)
}

export const isPreviewableStatus = (status: OrderStatus | null | undefined): status is PreviewableStatus => {
  return !!status && PREVIEWABLE_STATUSES.includes(status as PreviewableStatus)
}
